import FeatureFlag from './FeatureFlag';
export default FeatureFlag;
